<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-house"></i>
          ຈັດການຮ້ານຄ້າ Corporate
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>
      <div class="column is-6" v-if="$can(['SuperAdmin','marketing','manager'])">
        <vs-button circle icon flat @click="OpenModalAdd()"
                   style="padding-left: 8px; padding-right: 8px; float: right">
          <i class="fal fa-plus-circle"></i>
        </vs-button>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label style="margin-right: 10px; margin-top: 2px;" class="label">
              ຄົ້ນຫາ:
            </label>
            <input
              style="margin-top: 0.025rem;"
              class="input"
              type="text"
              name="searchItem"
              v-model="searchItem"
              @keyup.enter="FilterBySearch()"
            />
          </div>
        </div>
        <div class="column is-2">
            <div class="control">
              <label style="margin-right: 10px; margin-top: 2px;" class="label">
                ສະຖານນະຮ້ານ:</label>
              <div class="select" style="margin-top: 0.025rem;">
                <select class="input" v-model="shop_status" @change="FetchData">
                  <option value="">ທັງໝົດ</option>
                  <option value="open">ເປີດນໍາໃຊ້</option>
                  <option value="close">ປິດນໍາໃຊ້</option>
                </select>
              </div>
            </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label style="margin-right: 10px; margin-top: 2px;" class="label">
              ໃຊ້ແພັກເກດລາຄພິເສດ:</label>
            <div style="margin-top: 0.025rem;">
              <vs-checkbox v-model="has_special_package_price" @change="FetchData">ໃຊ້ລາຄາພິເສດ</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <div class="control" style="display: flex; align-items: flex-end; height: 100%;">
            <vs-button style=" margin-bottom: 0" circle icon flat @click="FilterBySearch()">
              <i class="fal fa-search"></i>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ຊື່ຮ້ານ</vs-th>
            <vs-th>ເບີໂທ</vs-th>
            <vs-th>ວັນທີສ້າງ</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th>ໃຊ້ແພັກເກດລາຄພິເສດ</vs-th>
            <vs-th>ແພັກເກດ</vs-th>
            <vs-th v-if="$can(['SuperAdmin','marketing','manager'])"></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="index"
            :data="shop"
            v-for="(shop, index) in $vs.getPage(shops, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ shop.name }}</vs-td>
            <vs-td>{{ shop.customer_tel }}</vs-td>
            <vs-td>{{ moment(shop.created_at).format("DD/MM/YYYY H:mm") }}</vs-td>
            <vs-td :style="{ color: shop.active ? 'green' : 'red' }">{{ laStatus[shop.active  ? "open" : "close"] }}</vs-td>
            <vs-td :style="{ color: shop.has_special_package_price ? 'green' : 'red' }">{{ shop.has_special_package_price ? 'ໃຊ້' : 'ບໍ່ໃຊ້' }}</vs-td>
            <vs-td>{{ getPackageName(shop) }}</vs-td>
            <vs-td style="text-align: right; width: 100px" v-if="$can(['SuperAdmin','marketing','manager'])">
              <div class="group-icon">
                <vs-button circle icon flat
                           @click="OpenModalEdit(shop)">
                  <i class="fad fa-pencil"></i>
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading" />
        </template>
      </vs-table>
    </div>
    <ModalAdd>
      <template v-slot="{ close }">
        <AddShop @close="close" @success="FetchData()" />
      </template>
    </ModalAdd>
    <ModalEdit>
      <template v-slot="{ close }">
        <EditShop @close="close"
                  :item="item"
                  @success="FetchData()" />
      </template>
    </ModalEdit>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import pagination from "@/Plugins/Paginations/Pagination";
import * as helper from "@/Helpers/GetValue";
import AddShop from "@/views/Corporate/Store/Dialog/Add";
import EditShop from "@/views/Corporate/Store/Dialog/Edit";

export default {
  components: {
    Loading,
    pagination,
    AddShop,
    EditShop,
  },

  data: () => ({
    laStatus: {
      "open": "ເປີດ",
      "close": "ປິດ"
    },
    page: 1,
    max: 10,
    isLoading: true,
    shop_status: "",
    has_special_package_price: false,
    shops: [],
    item: {},
    searchItem: "",
    oldVal: "",
    // Pagination
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {}
  }),
  watch: {
    "searchItem": function(value) {
      if (value === "") {
        this.FetchData();
      }
    }
  },
  methods: {
    FetchData() {
      this.isLoading = true;
      this.fetchItemsResponse().then((res) => {
        setTimeout(() => {
          this.shops = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
          this.oldVal = "";
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchItemsResponse(options = {}) {
      const { current_page, per_page } = options;
      const filters = {};

      if(this.shop_status !== "") {
        filters["is_active"] = this.shop_status === "open" ? "true" : "false"
      }

      if(this.has_special_package_price) {
        filters["has_special_package_price"] = "true"
      }

      return this.$http.get("v2/auth/store/management/corporate-stores", {
        params: {
          search: this.searchItem,
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
          ...filters
        }
      });
    },
    OpenModalEdit(shop) {
      this.item = JSON.parse(JSON.stringify(shop));
      this.$store.commit("modalEdit_State", true);
    },
    OpenModalAdd() {
      this.$store.commit("modalAdd_State", true);
    },
    FilterBySearch() {
      // Reset to page 1 when searching
      if (this.pagination.current_page !== 1) {
        this.pagination.current_page = 1;
      }
      helper.GetOldValueOnInput(this);
      this.FetchData();
    },

    getPackageName(shop) {
      if (shop.has_special_package_price) {
        if (shop.package_name_group === 'hal_express_package_special_group_lv01') {
          return 'ແພັກເກດພິເສດ ລະດັບ 1';
        } else if (shop.package_name_group === 'hal_express_package_special_group_lv02') {
          return 'ແພັກເກດພິເສດ ລະດັບ 2';
        } else if (shop.package_name_group === 'hal_express_package_special_group_lv03') {
          return 'ແພັກເກດພິເສດ ລະດັບ 3';
        } else if (shop.package_name_group === 'domestic_pricing_package_group') {
          return 'ແພັກເກດລາຄາພາຍໃນ';
        } else if (shop.package_name_group === 'domestic_pricing_south_package_group') {
          return 'ແພັກເກດລາຄາພາຍໃນສໍາລັບພາກໃຕ້';
        } else if (shop.package_name_group === 'flat_freight_package_group_01') {
          return 'ແພັກເກດລາຄາດຽວ 9,000';
        } else if (shop.package_name_group === 'flat_freight_package_group_02') {
          return 'ແພັກເກດລາຄາດຽວ 7,500 / 8,500';
        } else {
          return 'ແພັກເກດພິເສດສະເພາະຮ້ານ';
        }
      } else {
        return '-';
      }
    },

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF"
      });
    }
  },
  mounted() {
    this.shop_type = "open";
  },
  created() {
    this.shop_status = "open";
    this.FetchData();
  }
};
</script>
<style lang="scss" scoped>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
